export default [
	{
		family: 'Default',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'ABeeZee',
		variants: [400, '400i'],
		category: 'sans-serif'
	},
	{
		family: 'Abel',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Abhaya Libre',
		variants: [400, 500, 600, 700, 800],
		category: 'serif'
	},
	{
		family: 'Abril Fatface',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Aclonica',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Acme',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Actor',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Adamina',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Advent Pro',
		variants: [100, 200, 300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Aguafina Script',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Akaya Kanadaka',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Akaya Telivigala',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Akronim',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Aladin',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Alata',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Alatsi',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Aldrich',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Alef',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Alegreya',
		variants: [400, 500, 600, 700, 800, 900, '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'serif'
	},
	{
		family: 'Alegreya SC',
		variants: [400, '400i', 500, '500i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'serif'
	},
	{
		family: 'Alegreya Sans',
		variants: [100, '100i', 300, '300i', 400, '400i', 500, '500i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Alegreya Sans SC',
		variants: [100, '100i', 300, '300i', 400, '400i', 500, '500i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Aleo',
		variants: [300, '300i', 400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Alex Brush',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Alfa Slab One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Alice',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Alike',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Alike Angular',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Allan',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Allerta',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Allerta Stencil',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Allura',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Almarai',
		variants: [300, 400, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Almendra',
		variants: [400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Almendra Display',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Almendra SC',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Amarante',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Amaranth',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Amatic SC',
		variants: [400, 700],
		category: 'handwriting'
	},
	{
		family: 'Amethysta',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Amiko',
		variants: [400, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Amiri',
		variants: [400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Amita',
		variants: [400, 700],
		category: 'handwriting'
	},
	{
		family: 'Anaheim',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Andada',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Andika',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Andika New Basic',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Angkor',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Annie Use Your Telescope',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Anonymous Pro',
		variants: [400, '400i', 700, '700i'],
		category: 'monospace'
	},
	{
		family: 'Antic',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Antic Didone',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Antic Slab',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Anton',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Antonio',
		variants: [100, 200, 300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Arapey',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'Arbutus',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Arbutus Slab',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Architects Daughter',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Archivo',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Archivo Black',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Archivo Narrow',
		variants: [400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Aref Ruqaa',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Arima Madurai',
		variants: [100, 200, 300, 400, 500, 700, 800, 900],
		category: 'display'
	},
	{
		family: 'Arimo',
		variants: [400, 500, 600, 700, '400i', '500i', '600i', '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Arizonia',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Armata',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Arsenal',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Artifika',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Arvo',
		variants: [400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Arya',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Asap',
		variants: [400, 500, 600, 700, '400i', '500i', '600i', '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Asap Condensed',
		variants: [400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Asar',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Asset',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Assistant',
		variants: [200, 300, 400, 500, 600, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Astloch',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Asul',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Athiti',
		variants: [200, 300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Atma',
		variants: [300, 400, 500, 600, 700],
		category: 'display'
	},
	{
		family: 'Atomic Age',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Aubrey',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Audiowide',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Autour One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Average',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Average Sans',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Averia Gruesa Libre',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Averia Libre',
		variants: [300, '300i', 400, '400i', 700, '700i'],
		category: 'display'
	},
	{
		family: 'Averia Sans Libre',
		variants: [300, '300i', 400, '400i', 700, '700i'],
		category: 'display'
	},
	{
		family: 'Averia Serif Libre',
		variants: [300, '300i', 400, '400i', 700, '700i'],
		category: 'display'
	},
	{
		family: 'B612',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'B612 Mono',
		variants: [400, '400i', 700, '700i'],
		category: 'monospace'
	},
	{
		family: 'Bad Script',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Bahiana',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Bahianita',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Bai Jamjuree',
		variants: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Ballet',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Baloo 2',
		variants: [400, 500, 600, 700, 800],
		category: 'display'
	},
	{
		family: 'Baloo Bhai 2',
		variants: [400, 500, 600, 700, 800],
		category: 'display'
	},
	{
		family: 'Baloo Bhaina 2',
		variants: [400, 500, 600, 700, 800],
		category: 'display'
	},
	{
		family: 'Baloo Chettan 2',
		variants: [400, 500, 600, 700, 800],
		category: 'display'
	},
	{
		family: 'Baloo Da 2',
		variants: [400, 500, 600, 700, 800],
		category: 'display'
	},
	{
		family: 'Baloo Paaji 2',
		variants: [400, 500, 600, 700, 800],
		category: 'display'
	},
	{
		family: 'Baloo Tamma 2',
		variants: [400, 500, 600, 700, 800],
		category: 'display'
	},
	{
		family: 'Baloo Tammudu 2',
		variants: [400, 500, 600, 700, 800],
		category: 'display'
	},
	{
		family: 'Baloo Thambi 2',
		variants: [400, 500, 600, 700, 800],
		category: 'display'
	},
	{
		family: 'Balsamiq Sans',
		variants: [400, '400i', 700, '700i'],
		category: 'display'
	},
	{
		family: 'Balthazar',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Bangers',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Barlow',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Barlow Condensed',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Barlow Semi Condensed',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Barriecito',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Barrio',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Basic',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Baskervville',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'Battambang',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Baumans',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Bayon',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Be Vietnam',
		variants: [100, '100i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],
		category: 'sans-serif'
	},
	{
		family: 'Bebas Neue',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Belgrano',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Bellefair',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Belleza',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Bellota',
		variants: [300, '300i', 400, '400i', 700, '700i'],
		category: 'display'
	},
	{
		family: 'Bellota Text',
		variants: [300, '300i', 400, '400i', 700, '700i'],
		category: 'display'
	},
	{
		family: 'BenchNine',
		variants: [300, 400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Benne',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Bentham',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Berkshire Swash',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Beth Ellen',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Bevan',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Big Shoulders Display',
		variants: [100, 300, 400, 500, 600, 700, 800, 900],
		category: 'display'
	},
	{
		family: 'Big Shoulders Inline Display',
		variants: [100, 300, 400, 500, 600, 700, 800, 900],
		category: 'display'
	},
	{
		family: 'Big Shoulders Inline Text',
		variants: [100, 300, 400, 500, 600, 700, 800, 900],
		category: 'display'
	},
	{
		family: 'Big Shoulders Stencil Display',
		variants: [100, 300, 400, 500, 600, 700, 800, 900],
		category: 'display'
	},
	{
		family: 'Big Shoulders Stencil Text',
		variants: [100, 300, 400, 500, 600, 700, 800, 900],
		category: 'display'
	},
	{
		family: 'Big Shoulders Text',
		variants: [100, 300, 400, 500, 600, 700, 800, 900],
		category: 'display'
	},
	{
		family: 'Bigelow Rules',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Bigshot One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Bilbo',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Bilbo Swash Caps',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'BioRhyme',
		variants: [200, 300, 400, 700, 800],
		category: 'serif'
	},
	{
		family: 'BioRhyme Expanded',
		variants: [200, 300, 400, 700, 800],
		category: 'serif'
	},
	{
		family: 'Biryani',
		variants: [200, 300, 400, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Bitter',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'serif'
	},
	{
		family: 'Black And White Picture',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Black Han Sans',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Black Ops One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Blinker',
		variants: [100, 200, 300, 400, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Bodoni Moda',
		variants: [400, 500, 600, 700, 800, 900, '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'serif'
	},
	{
		family: 'Bokor',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Bonbon',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Boogaloo',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Bowlby One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Bowlby One SC',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Brawler',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Bree Serif',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Brygada 1918',
		variants: [400, 500, 600, 700, '400i', '500i', '600i', '700i'],
		category: 'serif'
	},
	{
		family: 'Bubblegum Sans',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Bubbler One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Buda',
		variants: [300, 400],
		category: 'display'
	},
	{
		family: 'Buenard',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Bungee',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Bungee Hairline',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Bungee Inline',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Bungee Outline',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Bungee Shade',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Butcherman',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Butterfly Kids',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Cabin',
		variants: [400, 500, 600, 700, '400i', '500i', '600i', '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Cabin Condensed',
		variants: [400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Cabin Sketch',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Caesar Dressing',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Cagliostro',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Cairo',
		variants: [200, 300, 400, 600, 700, 900],
		category: 'sans-serif'
	},
	{
		family: 'Caladea',
		variants: [400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Calistoga',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Calligraffitti',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Cambay',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Cambo',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Candal',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Cantarell',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Cantata One',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Cantora One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Capriola',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Cardo',
		variants: [400, '400i', 700],
		category: 'serif'
	},
	{
		family: 'Carme',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Carrois Gothic',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Carrois Gothic SC',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Carter One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Castoro',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'Catamaran',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Caudex',
		variants: [400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Caveat',
		variants: [400, 500, 600, 700],
		category: 'handwriting'
	},
	{
		family: 'Caveat Brush',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Cedarville Cursive',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Ceviche One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Chakra Petch',
		variants: [300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Changa',
		variants: [200, 300, 400, 500, 600, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Changa One',
		variants: [400, '400i'],
		category: 'display'
	},
	{
		family: 'Chango',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Charm',
		variants: [400, 700],
		category: 'handwriting'
	},
	{
		family: 'Charmonman',
		variants: [400, 700],
		category: 'handwriting'
	},
	{
		family: 'Chathura',
		variants: [100, 300, 400, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Chau Philomene One',
		variants: [400, '400i'],
		category: 'sans-serif'
	},
	{
		family: 'Chela One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Chelsea Market',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Chenla',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Cherry Cream Soda',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Cherry Swash',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Chewy',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Chicle',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Chilanka',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Chivo',
		variants: [300, '300i', 400, '400i', 700, '700i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Chonburi',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Cinzel',
		variants: [400, 500, 600, 700, 800, 900],
		category: 'serif'
	},
	{
		family: 'Cinzel Decorative',
		variants: [400, 700, 900],
		category: 'display'
	},
	{
		family: 'Clicker Script',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Coda',
		variants: [400, 800],
		category: 'display'
	},
	{
		family: 'Coda Caption',
		variants: [400, 800],
		category: 'sans-serif'
	},
	{
		family: 'Codystar',
		variants: [300, 400],
		category: 'display'
	},
	{
		family: 'Coiny',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Combo',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Comfortaa',
		variants: [300, 400, 500, 600, 700],
		category: 'display'
	},
	{
		family: 'Comic Neue',
		variants: [300, '300i', 400, '400i', 700, '700i'],
		category: 'handwriting'
	},
	{
		family: 'Coming Soon',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Commissioner',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Concert One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Condiment',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Content',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Contrail One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Convergence',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Cookie',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Copse',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Corben',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Cormorant',
		variants: [300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Cormorant Garamond',
		variants: [300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Cormorant Infant',
		variants: [300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Cormorant SC',
		variants: [300, 400, 500, 600, 700],
		category: 'serif'
	},
	{
		family: 'Cormorant Unicase',
		variants: [300, 400, 500, 600, 700],
		category: 'serif'
	},
	{
		family: 'Cormorant Upright',
		variants: [300, 400, 500, 600, 700],
		category: 'serif'
	},
	{
		family: 'Courgette',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Courier Prime',
		variants: [400, '400i', 700, '700i'],
		category: 'monospace'
	},
	{
		family: 'Cousine',
		variants: [400, '400i', 700, '700i'],
		category: 'monospace'
	},
	{
		family: 'Coustard',
		variants: [400, 900],
		category: 'serif'
	},
	{
		family: 'Covered By Your Grace',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Crafty Girls',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Creepster',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Crete Round',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'Crimson Pro',
		variants: [200, 300, 400, 500, 600, 700, 800, 900, '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'serif'
	},
	{
		family: 'Crimson Text',
		variants: [400, '400i', 600, '600i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Croissant One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Crushed',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Cuprum',
		variants: [400, 500, 600, 700, '400i', '500i', '600i', '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Cute Font',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Cutive',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Cutive Mono',
		variants: [400],
		category: 'monospace'
	},
	{
		family: 'DM Mono',
		variants: [300, '300i', 400, '400i', 500, '500i'],
		category: 'monospace'
	},
	{
		family: 'DM Sans',
		variants: [400, '400i', 500, '500i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'DM Serif Display',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'DM Serif Text',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'Damion',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Dancing Script',
		variants: [400, 500, 600, 700],
		category: 'handwriting'
	},
	{
		family: 'Dangrek',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Darker Grotesque',
		variants: [300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'David Libre',
		variants: [400, 500, 700],
		category: 'serif'
	},
	{
		family: 'Dawning of a New Day',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Days One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Dekko',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Dela Gothic One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Delius',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Delius Swash Caps',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Delius Unicase',
		variants: [400, 700],
		category: 'handwriting'
	},
	{
		family: 'Della Respira',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Denk One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Devonshire',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Dhurjati',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Didact Gothic',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Diplomata',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Diplomata SC',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Do Hyeon',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Dokdo',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Domine',
		variants: [400, 500, 600, 700],
		category: 'serif'
	},
	{
		family: 'Donegal One',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Doppio One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Dorsa',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Dosis',
		variants: [200, 300, 400, 500, 600, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'DotGothic16',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Dr Sugiyama',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Duru Sans',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Dynalight',
		variants: [400],
		category: 'display'
	},
	{
		family: 'EB Garamond',
		variants: [400, 500, 600, 700, 800, '400i', '500i', '600i', '700i', '800i'],
		category: 'serif'
	},
	{
		family: 'Eagle Lake',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'East Sea Dokdo',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Eater',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Economica',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Eczar',
		variants: [400, 500, 600, 700, 800],
		category: 'serif'
	},
	{
		family: 'El Messiri',
		variants: [400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Electrolize',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Elsie',
		variants: [400, 900],
		category: 'display'
	},
	{
		family: 'Elsie Swash Caps',
		variants: [400, 900],
		category: 'display'
	},
	{
		family: 'Emblema One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Emilys Candy',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Encode Sans',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Encode Sans Condensed',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Encode Sans Expanded',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Encode Sans Semi Condensed',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Encode Sans Semi Expanded',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Engagement',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Englebert',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Enriqueta',
		variants: [400, 500, 600, 700],
		category: 'serif'
	},
	{
		family: 'Epilogue',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Erica One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Esteban',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Euphoria Script',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Ewert',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Exo',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Exo 2',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'], category: 'sans-serif'
	},
	{
		family: 'Expletus Sans',
		variants: [400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'display'
	},
	{
		family: 'Fahkwang',
		variants: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Fanwood Text',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'Farro',
		variants: [300, 400, 500, 700],
		category: 'sans-serif'
	},
	{
		family: 'Farsan',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Fascinate',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Fascinate Inline',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Faster One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Fasthand',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Fauna One',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Faustina',
		variants: [400, 500, 600, 700, '400i', '500i', '600i', '700i'],
		category: 'serif'
	},
	{
		family: 'Federant',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Federo',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Felipa',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Fenix',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Finger Paint',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Fira Code',
		variants: [300, 400, 500, 600, 700],
		category: 'monospace'
	},
	{
		family: 'Fira Mono',
		variants: [400, 500, 700],
		category: 'monospace'
	},
	{
		family: 'Fira Sans',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Fira Sans Condensed',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Fira Sans Extra Condensed',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Fjalla One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Fjord One',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Flamenco',
		variants: [300, 400],
		category: 'display'
	},
	{
		family: 'Flavors',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Fondamento',
		variants: [400, '400i'],
		category: 'handwriting'
	},
	{
		family: 'Fontdiner Swanky',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Forum',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Francois One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Frank Ruhl Libre',
		variants: [300, 400, 500, 700, 900],
		category: 'serif'
	},
	{
		family: 'Fraunces',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'serif'
	},
	{
		family: 'Freckle Face',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Fredericka the Great',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Fredoka One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Freehand',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Fresca',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Frijole',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Fruktur',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Fugaz One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'GFS Didot',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'GFS Neohellenic',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Gabriela',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Gaegu',
		variants: [300, 400, 700],
		category: 'handwriting'
	},
	{
		family: 'Gafata',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Galada',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Galdeano',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Galindo',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Gamja Flower',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Gayathri',
		variants: [100, 400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Gelasio',
		variants: [400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Gentium Basic',
		variants: [400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Gentium Book Basic',
		variants: [400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Geo',
		variants: [400, '400i'],
		category: 'sans-serif'
	},
	{
		family: 'Geostar',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Geostar Fill',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Germania One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Gidugu',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Gilda Display',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Girassol',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Give You Glory',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Glass Antiqua',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Glegoo',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Gloria Hallelujah',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Goblin One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Gochi Hand',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Goldman',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Gorditas',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Gothic A1',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Gotu',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Goudy Bookletter 1911',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Graduate',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Grand Hotel',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Grandstander',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'display'
	},
	{
		family: 'Gravitas One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Great Vibes',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Grenze',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'serif'
	},
	{
		family: 'Grenze Gotisch',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'display'
	},
	{
		family: 'Griffy',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Gruppo',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Gudea',
		variants: [400, '400i', 700],
		category: 'sans-serif'
	},
	{
		family: 'Gugi',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Gupter',
		variants: [400, 500, 700],
		category: 'serif'
	},
	{
		family: 'Gurajada',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Habibi',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Hachi Maru Pop',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Halant',
		variants: [300, 400, 500, 600, 700],
		category: 'serif'
	},
	{
		family: 'Hammersmith One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Hanalei',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Hanalei Fill',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Handlee',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Hanuman',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Happy Monkey',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Harmattan',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Headland One',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Heebo',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Henny Penny',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Hepta Slab',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'serif'
	},
	{
		family: 'Herr Von Muellerhoff',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Hi Melody',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Hind',
		variants: [300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Hind Guntur',
		variants: [300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Hind Madurai',
		variants: [300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Hind Siliguri',
		variants: [300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Hind Vadodara',
		variants: [300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Holtwood One SC',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Homemade Apple',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Homenaje',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'IBM Plex Mono',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'monospace'
	},
	{
		family: 'IBM Plex Sans',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'IBM Plex Sans Condensed',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'IBM Plex Serif',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'IM Fell DW Pica',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'IM Fell DW Pica SC',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'IM Fell Double Pica',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'IM Fell Double Pica SC',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'IM Fell English',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'IM Fell English SC',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'IM Fell French Canon',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'IM Fell French Canon SC',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'IM Fell Great Primer',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'IM Fell Great Primer SC',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Ibarra Real Nova',
		variants: [400, 500, 600, 700, '400i', '500i', '600i', '700i'],
		category: 'serif'
	},
	{
		family: 'Iceberg',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Iceland',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Imbue',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'serif'
	},
	{
		family: 'Imprima',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Inconsolata',
		variants: [200, 300, 400, 500, 600, 700, 800, 900],
		category: 'monospace'
	},
	{
		family: 'Inder',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Indie Flower',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Inika',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Inknut Antiqua',
		variants: [300, 400, 500, 600, 700, 800, 900],
		category: 'serif'
	},
	{
		family: 'Inria Sans',
		variants: [300, '300i', 400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Inria Serif',
		variants: [300, '300i', 400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Inter',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Irish Grover',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Istok Web',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Italiana',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Italianno',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Itim',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Jacques Francois',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Jacques Francois Shadow',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Jaldi',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'JetBrains Mono',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i'],
		category: 'monospace'
	},
	{
		family: 'Jim Nightshade',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Jockey One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Jolly Lodger',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Jomhuria',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Jomolhari',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Josefin Sans',
		variants: [100, 200, 300, 400, 500, 600, 700, '100i', '200i', '300i', '400i', '500i', '600i', '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Josefin Slab',
		variants: [100, 200, 300, 400, 500, 600, 700, '100i', '200i', '300i', '400i', '500i', '600i', '700i'],
		category: 'serif'
	},
	{
		family: 'Jost',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Joti One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Jua',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Judson',
		variants: [400, '400i', 700],
		category: 'serif'
	},
	{
		family: 'Julee',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Julius Sans One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Junge',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Jura',
		variants: [300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Just Another Hand',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Just Me Again Down Here',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'K2D',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],
		category: 'sans-serif'
	},
	{
		family: 'Kadwa',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Kalam',
		variants: [300, 400, 700],
		category: 'handwriting'
	},
	{
		family: 'Kameron',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Kanit',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Kantumruy',
		variants: [300, 400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Karantina',
		variants: [300, 400, 700],
		category: 'display'
	},
	{
		family: 'Karla',
		variants: [200, 300, 400, 500, 600, 700, 800, '200i', '300i', '400i', '500i', '600i', '700i', '800i'],
		category: 'sans-serif'
	},
	{
		family: 'Karma',
		variants: [300, 400, 500, 600, 700],
		category: 'serif'
	},
	{
		family: 'Katibeh',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Kaushan Script',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Kavivanar',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Kavoon',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Kdam Thmor',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Keania One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Kelly Slab',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Kenia',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Khand',
		variants: [300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Khmer',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Khula',
		variants: [300, 400, 600, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Kirang Haerang',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Kite One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Kiwi Maru',
		variants: [300, 400, 500],
		category: 'serif'
	},
	{
		family: 'Knewave',
		variants: [400],
		category: 'display'
	},
	{
		family: 'KoHo',
		variants: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Kodchasan',
		variants: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Kosugi',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Kosugi Maru',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Kotta One',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Koulen',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Kranky',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Kreon',
		variants: [300, 400, 500, 600, 700],
		category: 'serif'
	},
	{
		family: 'Kristi',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Krona One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Krub',
		variants: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Kufam',
		variants: [400, 500, 600, 700, 800, 900, '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'display'
	},
	{
		family: 'Kulim Park',
		variants: [200, '200i', 300, '300i', 400, '400i', 600, '600i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Kumar One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Kumar One Outline',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Kumbh Sans',
		variants: [300, 400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Kurale',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'La Belle Aurore',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Lacquer',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Laila',
		variants: [300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Lakki Reddy',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Lalezar',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Lancelot',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Langar',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Lateef',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Lato',
		variants: [100, '100i', 300, '300i', 400, '400i', 700, '700i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'League Script',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Leckerli One',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Ledger',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Lekton',
		variants: [400, '400i', 700],
		category: 'sans-serif'
	},
	{
		family: 'Lemon',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Lemonada',
		variants: [300, 400, 500, 600, 700],
		category: 'display'
	},
	{
		family: 'Lexend',
		variants: [100, 300, 400, 500, 600, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Lexend Deca',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Lexend Exa',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Lexend Giga',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Lexend Mega',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Lexend Peta',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Lexend Tera',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Lexend Zetta',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Libre Barcode 128',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Libre Barcode 128 Text',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Libre Barcode 39',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Libre Barcode 39 Extended',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Libre Barcode 39 Extended Text',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Libre Barcode 39 Text',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Libre Barcode EAN13 Text',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Libre Baskerville',
		variants: [400, '400i', 700],
		category: 'serif'
	},
	{
		family: 'Libre Caslon Display',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Libre Caslon Text',
		variants: [400, '400i', 700],
		category: 'serif'
	},
	{
		family: 'Libre Franklin',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Life Savers',
		variants: [400, 700, 800],
		category: 'display'
	},
	{
		family: 'Lilita One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Lily Script One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Limelight',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Linden Hill',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'Literata',
		variants: [200, 300, 400, 500, 600, 700, 800, 900, '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'serif'
	},
	{
		family: 'Liu Jian Mao Cao',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Livvic',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Lobster',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Lobster Two',
		variants: [400, '400i', 700, '700i'],
		category: 'display'
	},
	{
		family: 'Londrina Outline',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Londrina Shadow',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Londrina Sketch',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Londrina Solid',
		variants: [100, 300, 400, 900],
		category: 'display'
	},
	{
		family: 'Long Cang',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Lora',
		variants: [400, 500, 600, 700, '400i', '500i', '600i', '700i'],
		category: 'serif'
	},
	{
		family: 'Love Ya Like A Sister',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Loved by the King',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Lovers Quarrel',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Luckiest Guy',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Lusitana',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Lustria',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'M PLUS 1p',
		variants: [100, 300, 400, 500, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'M PLUS Rounded 1c',
		variants: [100, 300, 400, 500, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Ma Shan Zheng',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Macondo',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Macondo Swash Caps',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Mada',
		variants: [200, 300, 400, 500, 600, 700, 900],
		category: 'sans-serif'
	},
	{
		family: 'Magra',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Maiden Orange',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Maitree',
		variants: [200, 300, 400, 500, 600, 700],
		category: 'serif'
	},
	{
		family: 'Major Mono Display',
		variants: [400],
		category: 'monospace'
	},
	{
		family: 'Mako',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Mali',
		variants: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'handwriting'
	},
	{
		family: 'Mallanna',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Mandali',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Manjari',
		variants: [100, 400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Manrope',
		variants: [200, 300, 400, 500, 600, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Mansalva',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Manuale',
		variants: [400, 500, 600, 700, '400i', '500i', '600i', '700i'],
		category: 'serif'
	},
	{
		family: 'Marcellus',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Marcellus SC',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Marck Script',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Margarine',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Markazi Text',
		variants: [400, 500, 600, 700],
		category: 'serif'
	},
	{
		family: 'Marko One',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Marmelad',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Martel',
		variants: [200, 300, 400, 600, 700, 800, 900],
		category: 'serif'
	},
	{
		family: 'Martel Sans',
		variants: [200, 300, 400, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Marvel',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Mate',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'Mate SC',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Maven Pro',
		variants: [400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'McLaren',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Meddon',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'MedievalSharp',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Medula One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Meera Inimai',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Megrim',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Meie Script',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Merienda',
		variants: [400, 700],
		category: 'handwriting'
	},
	{
		family: 'Merienda One',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Merriweather',
		variants: [300, '300i', 400, '400i', 700, '700i', 900, '900i'],
		category: 'serif'
	},
	{
		family: 'Merriweather Sans',
		variants: [300, 400, 500, 600, 700, 800, '300i', '400i', '500i', '600i', '700i', '800i'],
		category: 'sans-serif'
	},
	{
		family: 'Metal',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Metal Mania',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Metamorphous',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Metrophobic',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Michroma',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Milonga',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Miltonian',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Miltonian Tattoo',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Mina',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Miniver',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Miriam Libre',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Mirza',
		variants: [400, 500, 600, 700],
		category: 'display'
	},
	{
		family: 'Miss Fajardose',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Mitr',
		variants: [200, 300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Modak',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Modern Antiqua',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Mogra',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Molengo',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Molle',
		variants: [400, '400i'],
		category: 'handwriting'
	},
	{
		family: 'Monda',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Monofett',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Monoton',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Monsieur La Doulaise',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Montaga',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Montez',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Montserrat',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Montserrat Alternates',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Montserrat Subrayada',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Moul',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Moulpali',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Mountains of Christmas',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Mouse Memoirs',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Mr Bedfort',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Mr Dafoe',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Mr De Haviland',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Mrs Saint Delafield',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Mrs Sheppards',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Mukta',
		variants: [200, 300, 400, 500, 600, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Mukta Mahee',
		variants: [200, 300, 400, 500, 600, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Mukta Malar',
		variants: [200, 300, 400, 500, 600, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Mukta Vaani',
		variants: [200, 300, 400, 500, 600, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Mulish',
		variants: [200, 300, 400, 500, 600, 700, 800, 900, '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'sans-serif'
	},
	{
		family: 'MuseoModerno',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'display'
	},
	{
		family: 'Mystery Quest',
		variants: [400],
		category: 'display'
	},
	{
		family: 'NTR',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Nanum Brush Script',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Nanum Gothic',
		variants: [400, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Nanum Gothic Coding',
		variants: [400, 700],
		category: 'monospace'
	},
	{
		family: 'Nanum Myeongjo',
		variants: [400, 700, 800],
		category: 'serif'
	},
	{
		family: 'Nanum Pen Script',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Nerko One',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Neucha',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Neuton',
		variants: [200, 300, 400, '400i', 700, 800],
		category: 'serif'
	},
	{
		family: 'New Rocker',
		variants: [400],
		category: 'display'
	},
	{
		family: 'New Tegomin',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'News Cycle',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Newsreader',
		variants: [200, 300, 400, 500, 600, 700, 800, '200i', '300i', '400i', '500i', '600i', '700i', '800i'],
		category: 'serif'
	},
	{
		family: 'Niconne',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Niramit',
		variants: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Nixie One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Nobile',
		variants: [400, '400i', 500, '500i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Nokora',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Norican',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Nosifer',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Notable',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Nothing You Could Do',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Noticia Text',
		variants: [400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Noto Sans',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Noto Sans HK',
		variants: [100, 300, 400, 500, 700, 900],
		category: 'sans-serif'
	},
	{
		family: 'Noto Sans JP',
		variants: [100, 300, 400, 500, 700, 900],
		category: 'sans-serif'
	},
	{
		family: 'Noto Sans KR',
		variants: [100, 300, 400, 500, 700, 900],
		category: 'sans-serif'
	},
	{
		family: 'Noto Sans SC',
		variants: [100, 300, 400, 500, 700, 900],
		category: 'sans-serif'
	},
	{
		family: 'Noto Sans TC',
		variants: [100, 300, 400, 500, 700, 900],
		category: 'sans-serif'
	},
	{
		family: 'Noto Serif',
		variants: [400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Noto Serif JP',
		variants: [200, 300, 400, 500, 600, 700, 900],
		category: 'serif'
	},
	{
		family: 'Noto Serif KR',
		variants: [200, 300, 400, 500, 600, 700, 900],
		category: 'serif'
	},
	{
		family: 'Noto Serif SC',
		variants: [200, 300, 400, 500, 600, 700, 900],
		category: 'serif'
	},
	{
		family: 'Noto Serif TC',
		variants: [200, 300, 400, 500, 600, 700, 900],
		category: 'serif'
	},
	{
		family: 'Nova Cut',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Nova Flat',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Nova Mono',
		variants: [400],
		category: 'monospace'
	},
	{
		family: 'Nova Oval',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Nova Round',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Nova Script',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Nova Slim',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Nova Square',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Numans',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Nunito',
		variants: [200, '200i', 300, '300i', 400, '400i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Nunito Sans',
		variants: [200, '200i', 300, '300i', 400, '400i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Odibee Sans',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Odor Mean Chey',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Offside',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Oi',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Old Standard TT',
		variants: [400, '400i', 700],
		category: 'serif'
	},
	{
		family: 'Oldenburg',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Oleo Script',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Oleo Script Swash Caps',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Open Sans',
		variants: [300, '300i', 400, '400i', 600, '600i', 700, '700i', 800, '800i'],
		category: 'sans-serif'
	},
	{
		family: 'Open Sans Condensed',
		variants: [300, '300i', 400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Oranienbaum',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Orbitron',
		variants: [400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Oregano',
		variants: [400, '400i'],
		category: 'display'
	},
	{
		family: 'Orelega One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Orienta',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Original Surfer',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Oswald',
		variants: [200, 300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Over the Rainbow',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Overlock',
		variants: [400, '400i', 700, '700i', 900, '900i'],
		category: 'display'
	},
	{
		family: 'Overlock SC',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Overpass',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Overpass Mono',
		variants: [300, 400, 600, 700],
		category: 'monospace'
	},
	{
		family: 'Ovo',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Oxanium',
		variants: [200, 300, 400, 500, 600, 700, 800],
		category: 'display'
	},
	{
		family: 'Oxygen',
		variants: [300, 400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Oxygen Mono',
		variants: [400],
		category: 'monospace'
	},
	{
		family: 'PT Mono',
		variants: [400],
		category: 'monospace'
	},
	{
		family: 'PT Sans',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'PT Sans Caption',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'PT Sans Narrow',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'PT Serif',
		variants: [400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'PT Serif Caption',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'Pacifico',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Padauk',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Palanquin',
		variants: [100, 200, 300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Palanquin Dark',
		variants: [400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Pangolin',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Paprika',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Parisienne',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Passero One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Passion One',
		variants: [400, 700, 900],
		category: 'display'
	},
	{
		family: 'Pathway Gothic One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Patrick Hand',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Patrick Hand SC',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Pattaya',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Patua One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Pavanam',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Paytone One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Peddana',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Peralta',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Permanent Marker',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Petit Formal Script',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Petrona',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'serif'
	},
	{
		family: 'Philosopher',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Piazzolla',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'serif'
	},
	{
		family: 'Piedra',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Pinyon Script',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Pirata One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Plaster',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Play',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Playball',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Playfair Display',
		variants: [400, 500, 600, 700, 800, 900, '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'serif'
	},
	{
		family: 'Playfair Display SC',
		variants: [400, '400i', 700, '700i', 900, '900i'],
		category: 'serif'
	},
	{
		family: 'Podkova',
		variants: [400, 500, 600, 700, 800],
		category: 'serif'
	},
	{
		family: 'Poiret One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Poller One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Poly',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'Pompiere',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Pontano Sans',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Poor Story',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Poppins',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Port Lligat Sans',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Port Lligat Slab',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Potta One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Pragati Narrow',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Prata',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Preahvihear',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Press Start 2P',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Pridi',
		variants: [200, 300, 400, 500, 600, 700],
		category: 'serif'
	},
	{
		family: 'Princess Sofia',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Prociono',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Prompt',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Prosto One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Proza Libre',
		variants: [400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],
		category: 'sans-serif'
	},
	{
		family: 'Public Sans',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Puritan',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Purple Purse',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Quando',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Quantico',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Quattrocento',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Quattrocento Sans',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Questrial',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Quicksand',
		variants: [300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Quintessential',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Qwigley',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Racing Sans One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Radley',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'Rajdhani',
		variants: [300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Rakkas',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Raleway',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Raleway Dots',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Ramabhadra',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Ramaraja',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Rambla',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Rammetto One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Ranchers',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Rancho',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Ranga',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Rasa',
		variants: [300, 400, 500, 600, 700],
		category: 'serif'
	},
	{
		family: 'Rationale',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Ravi Prakash',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Recursive',
		variants: [300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Red Hat Display',
		variants: [400, '400i', 500, '500i', 700, '700i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Red Hat Text',
		variants: [400, '400i', 500, '500i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Red Rose',
		variants: [300, 400, 500, 600, 700],
		category: 'display'
	},
	{
		family: 'Redressed',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Reem Kufi',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Reenie Beanie',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Reggae One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Revalia',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Rhodium Libre',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Ribeye',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Ribeye Marrow',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Righteous',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Risque',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Roboto',
		variants: [100, '100i', 300, '300i', 400, '400i', 500, '500i', 700, '700i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Roboto Condensed',
		variants: [300, '300i', 400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Roboto Mono',
		variants: [100, 200, 300, 400, 500, 600, 700, '100i', '200i', '300i', '400i', '500i', '600i', '700i'],
		category: 'monospace'
	},
	{
		family: 'Roboto Slab',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'serif'
	},
	{
		family: 'Rochester',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Rock Salt',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'RocknRoll One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Rokkitt',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'serif'
	},
	{
		family: 'Romanesco',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Ropa Sans',
		variants: [400, '400i'],
		category: 'sans-serif'
	},
	{
		family: 'Rosario',
		variants: [300, 400, 500, 600, 700, '300i', '400i', '500i', '600i', '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Rosarivo',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'Rouge Script',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Rowdies',
		variants: [300, 400, 700],
		category: 'display'
	},
	{
		family: 'Rozha One',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Rubik',
		variants: [300, 400, 500, 600, 700, 800, 900, '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Rubik Mono One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Ruda',
		variants: [400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Rufina',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Ruge Boogie',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Ruluko',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Rum Raisin',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Ruslan Display',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Russo One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Ruthie',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Rye',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Sacramento',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Sahitya',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Sail',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Saira',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Saira Condensed',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Saira Extra Condensed',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Saira Semi Condensed',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Saira Stencil One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Salsa',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Sanchez',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'Sancreek',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Sansita',
		variants: [400, '400i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Sansita Swashed',
		variants: [300, 400, 500, 600, 700, 800, 900],
		category: 'display'
	},
	{
		family: 'Sarabun',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],
		category: 'sans-serif'
	},
	{
		family: 'Sarala',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Sarina',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Sarpanch',
		variants: [400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Satisfy',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Sawarabi Gothic',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Sawarabi Mincho',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Scada',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Scheherazade',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Schoolbell',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Scope One',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Seaweed Script',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Secular One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Sedgwick Ave',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Sedgwick Ave Display',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Sen',
		variants: [400, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Sevillana',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Seymour One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Shadows Into Light',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Shadows Into Light Two',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Shanti',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Share',
		variants: [400, '400i', 700, '700i'],
		category: 'display'
	},
	{
		family: 'Share Tech',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Share Tech Mono',
		variants: [400],
		category: 'monospace'
	},
	{
		family: 'Shippori Mincho',
		variants: [400, 500, 600, 700, 800],
		category: 'serif'
	},
	{
		family: 'Shippori Mincho B1',
		variants: [400, 500, 600, 700, 800],
		category: 'serif'
	},
	{
		family: 'Shojumaru',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Short Stack',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Shrikhand',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Siemreap',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Sigmar One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Signika',
		variants: [300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Signika Negative',
		variants: [300, 400, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Simonetta',
		variants: [400, '400i', 900, '900i'],
		category: 'display'
	},
	{
		family: 'Single Day',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Sintony',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Sirin Stencil',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Six Caps',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Skranji',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Slabo 13px',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Slabo 27px',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Slackey',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Smokum',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Smythe',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Sniglet',
		variants: [400, 800],
		category: 'display'
	},
	{
		family: 'Snippet',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Snowburst One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Sofadi One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Sofia',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Solway',
		variants: [300, 400, 500, 700, 800],
		category: 'serif'
	},
	{
		family: 'Song Myung',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Sonsie One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Sora',
		variants: [100, 200, 300, 400, 500, 600, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Sorts Mill Goudy',
		variants: [400, '400i'],
		category: 'serif'
	},
	{
		family: 'Source Code Pro',
		variants: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 900, '900i'],
		category: 'monospace'
	},
	{
		family: 'Source Sans Pro',
		variants: [200, '200i', 300, '300i', 400, '400i', 600, '600i', 700, '700i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Source Serif Pro',
		variants: [200, '200i', 300, '300i', 400, '400i', 600, '600i', 700, '700i', 900, '900i'],
		category: 'serif'
	},
	{
		family: 'Space Grotesk',
		variants: [300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Space Mono',
		variants: [400, '400i', 700, '700i'],
		category: 'monospace'
	},
	{
		family: 'Spartan',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Special Elite',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Spectral',
		variants: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],
		category: 'serif'
	},
	{
		family: 'Spectral SC',
		variants: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],
		category: 'serif'
	},
	{
		family: 'Spicy Rice',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Spinnaker',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Spirax',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Squada One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Sree Krushnadevaraya',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Sriracha',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Srisakdi',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Staatliches',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Stalemate',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Stalinist One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Stardos Stencil',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Stick',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Stint Ultra Condensed',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Stint Ultra Expanded',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Stoke',
		variants: [300, 400],
		category: 'serif'
	},
	{
		family: 'Strait',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Stylish',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Sue Ellen Francisco',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Suez One',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Sulphur Point',
		variants: [300, 400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Sumana',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Sunflower',
		variants: [300, 400, 500, 700],
		category: 'sans-serif'
	},
	{
		family: 'Sunshiney',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Supermercado One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Sura',
		variants: [400, 700],
		category: 'serif'
	},
	{
		family: 'Suranna',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Suravaram',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Suwannaphum',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Swanky and Moo Moo',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Syncopate',
		variants: [400, 700],
		category: 'sans-serif'
	},
	{
		family: 'Syne',
		variants: [400, 500, 600, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Syne Mono',
		variants: [400],
		category: 'monospace'
	},
	{
		family: 'Syne Tactile',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Tajawal',
		variants: [200, 300, 400, 500, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Tangerine',
		variants: [400, 700],
		category: 'handwriting'
	},
	{
		family: 'Taprom',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Tauri',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Taviraj',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'serif'
	},
	{
		family: 'Teko',
		variants: [300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Telex',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Tenali Ramakrishna',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Tenor Sans',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Text Me One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Texturina',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'serif'
	},
	{
		family: 'Thasadith',
		variants: [400, '400i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'The Girl Next Door',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Tienne',
		variants: [400, 700, 900],
		category: 'serif'
	},
	{
		family: 'Tillana',
		variants: [400, 500, 600, 700, 800],
		category: 'handwriting'
	},
	{
		family: 'Timmana',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Tinos',
		variants: [400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Titan One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Titillium Web',
		variants: [200, '200i', 300, '300i', 400, '400i', 600, '600i', 700, '700i', 900],
		category: 'sans-serif'
	},
	{
		family: 'Tomorrow',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Trade Winds',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Train One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Trirong',
		variants: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],
		category: 'serif'
	},
	{
		family: 'Trispace',
		variants: [100, 200, 300, 400, 500, 600, 700, 800],
		category: 'sans-serif'
	},
	{
		family: 'Trocchi',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Trochut',
		variants: [400, '400i', 700],
		category: 'display'
	},
	{
		family: 'Truculenta',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900],
		category: 'sans-serif'
	},
	{
		family: 'Trykker',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Tulpen One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Turret Road',
		variants: [200, 300, 400, 500, 700, 800],
		category: 'display'
	},
	{
		family: 'Ubuntu',
		variants: [300, '300i', 400, '400i', 500, '500i', 700, '700i'],
		category: 'sans-serif'
	},
	{
		family: 'Ubuntu Condensed',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Ubuntu Mono',
		variants: [400, '400i', 700, '700i'],
		category: 'monospace'
	},
	{
		family: 'Ultra',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Uncial Antiqua',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Underdog',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Unica One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'UnifrakturCook',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'UnifrakturMaguntia',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Unkempt',
		variants: [400, 700],
		category: 'display'
	},
	{
		family: 'Unlock',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Unna',
		variants: [400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'VT323',
		variants: [400],
		category: 'monospace'
	},
	{
		family: 'Vampiro One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Varela',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Varela Round',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Varta',
		variants: [300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Vast Shadow',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Vesper Libre',
		variants: [400, 500, 700, 900],
		category: 'serif'
	},
	{
		family: 'Viaoda Libre',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Vibes',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Vibur',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Vidaloka',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Viga',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Voces',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Volkhov',
		variants: [400, '400i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Vollkorn',
		variants: [400, 500, 600, 700, 800, 900, '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'serif'
	},
	{
		family: 'Vollkorn SC',
		variants: [400, 600, 700, 900],
		category: 'serif'
	},
	{
		family: 'Voltaire',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Waiting for the Sunrise',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Wallpoet',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Walter Turncoat',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Warnes',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Wellfleet',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Wendy One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Wire One',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'Work Sans',
		variants: [100, 200, 300, 400, 500, 600, 700, 800, 900, '100i', '200i', '300i', '400i', '500i', '600i', '700i', '800i', '900i'],
		category: 'sans-serif'
	},
	{
		family: 'Xanh Mono',
		variants: [400, '400i'],
		category: 'monospace'
	},
	{
		family: 'Yanone Kaffeesatz',
		variants: [200, 300, 400, 500, 600, 700],
		category: 'sans-serif'
	},
	{
		family: 'Yantramanav',
		variants: [100, 300, 400, 500, 700, 900],
		category: 'sans-serif'
	},
	{
		family: 'Yatra One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Yellowtail',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Yeon Sung',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Yeseva One',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Yesteryear',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Yrsa',
		variants: [300, 400, 500, 600, 700],
		category: 'serif'
	},
	{
		family: 'Yusei Magic',
		variants: [400],
		category: 'sans-serif'
	},
	{
		family: 'ZCOOL KuaiLe',
		variants: [400],
		category: 'display'
	},
	{
		family: 'ZCOOL QingKe HuangYou',
		variants: [400],
		category: 'display'
	},
	{
		family: 'ZCOOL XiaoWei',
		variants: [400],
		category: 'serif'
	},
	{
		family: 'Zen Dots',
		variants: [400],
		category: 'display'
	},
	{
		family: 'Zeyada',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Zhi Mang Xing',
		variants: [400],
		category: 'handwriting'
	},
	{
		family: 'Zilla Slab',
		variants: [300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i'],
		category: 'serif'
	},
	{
		family: 'Zilla Slab Highlight',
		variants: [400, 700],
		category: 'display'
	}
];